import React, { forwardRef } from 'react';
import { string, bool, func } from 'prop-types';
import { translate, I18n } from '@fiverr-private/i18n-react';
import { FormInput } from '../../../../shared/FormInput';
import { STATUS } from '../../services/userNameAvailability';
import { USERNAME_VALIDATION } from '../../fields/username';
import { LoginLink } from '../../../../shared/LoginLink';

const usernameErrorMessage = (reason) => {
    switch (reason) {
        case STATUS.TAKEN:
            return usernameNotAvailable();
        case STATUS.SERVICE_ERROR:
            return translate('affiliates_signup_perseus.errors.username_service_error');
        case USERNAME_VALIDATION.MIN_LENGTH:
        case USERNAME_VALIDATION.INVALID_CHARACTERS:
        default:
            return translate('affiliates_signup_perseus.errors.username');
    }
};

const usernameNotAvailable = () => {
    const templates = {
        login: (label) => <LoginLink>{label}</LoginLink>,
    };

    return <I18n k="affiliates_signup_perseus.errors.user_na" templates={templates} />;
};

export const Username = forwardRef((props, ref) => {
    const { value, onFocus, onChange, onBlur, valid, dirty, pending, reason } = props;

    return (
        <FormInput
            value={value}
            onFocus={onFocus}
            onChange={onChange}
            onBlur={onBlur}
            valid={valid}
            dirty={dirty}
            pending={pending}
            placeholder={translate('affiliates_signup_perseus.personal_info.username')}
            isRequired
            ref={ref}
            autoComplete="username"
            errorMessage={usernameErrorMessage(reason)}
        />
    );
});

Username.displayName = 'Username';

Username.propTypes = {
    value: string,
    reason: string,
    onFocus: func,
    onChange: func,
    onBlur: func,
    valid: bool,
    dirty: bool,
    pending: bool,
};
